// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ov9X","name":"styles_name__bb5JD","phone":"styles_phone__3L3rf"};